<!-- 提现账号 -->
<template>
  <div class="phone-container">
    <div class="tab-view">
      <div style="
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e0e0e0;
        ">
        <div class="tab-item" style="margin-right: 100px" @click="tabAction(0)">
          <div :style="tab == 0 ? ' color: #488eff' : ''">支付宝账号</div>
          <div class="tab-line" v-show="tab == 0"></div>
        </div>
        <!-- <div class="tab-item" @click="tabAction(1)">
          <div :style="tab != 0 ? ' color: #488eff' : ''">银行卡账号</div>
          <div class="tab-line" v-show="tab != 0"></div>
        </div> -->
      </div>
    </div>
    <div v-if="list.length == 0">
      <div >
        <div v-if="pageData.credentialLevel==0" class="no-autonym" >
        <img src="../../assets/image/renzehng3.png" alt="" />
        <div>
          您还没有进行实名认证，无法添加账号<br /><br />
          如有问题，请联系客服咨询
        </div>
        <el-button type="primary" style="margin-top: 20px" @click="accountClick(5.4)">实名认证</el-button>
      </div>
        <div class="no-data" v-if="list.length == 0 && pageData.credentialLevel!=0 ">
          <!-- empty.DwW3vaOQ -->
          <img src="@/assets/newImage/empty.DwW3vaOQ.png" alt="" />
          <div class="no-data-title">暂未添加账号~！</div>
          <el-button type="primary" style="margin-top: 20px" @click="addAcc">添加</el-button>
        </div>
    
    
    </div>
    </div>
    <div v-else style="width: 100%;  padding: 0 20%; padding-top: 50px;">
      <div class="item-view" v-for="item in list"   :key="item.id">
        <div class="item-left">
          <img :src="item.icon" alt="">
          <div class="flex-column-ct" style="margin-left: 20px; font-size: 14px; align-items: self-start; ">
            <div>{{ item.name }}</div>
            <div style="padding: 5px 0px;">身份证号:{{ item.idNum }}</div>
            <div>支付宝账号:{{ item.account }}</div>
          </div>
        </div>
        <el-button type="danger" icon="el-icon-delete" circle @click="accountDel(item)"></el-button>
      </div>
    </div>


    <el-dialog :title="title" :visible.sync="dialogVisible" width="40%" :before-close="cancel">
      <div class="withdraw-account-form">
        <el-form :model="form" label-width="120px">
          <el-form-item label="开户人姓名：">
            <span>{{ form.accountHolderName }}</span>
          </el-form-item>
          <el-form-item label="身份证号码：">
            <span>{{ form.idNumber }}</span>
          </el-form-item>
          <el-form-item label="支付宝账号：" prop="account">
            <el-input v-model="form.account" placeholder="请输入您的支付宝账号"></el-input>
          </el-form-item>
          <el-form-item label="交易密码：" prop="fundPwd">
            <div style="display: flex; align-items: center">
              <el-input v-model="form.fundPwd" type="password" placeholder="请输入交易密码"></el-input>
              <span style="margin-left: -100px; z-index: 999; color: #488eff" @click="accountClick(5.3)">忘记交易密码</span>
            </div>
          </el-form-item>
          <el-form-item>
            <div style="display: flex; justify-content: flex-end">
              <el-button @click="cancel">取消</el-button>
              <el-button type="primary" @click="addAccount">立即添加</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from "@/utils/http/axios";
export default {
  props: {
    userData: Object,
  },
  data() {
    return {
      input: "",
      tab: 0,
      dialogVisible: false,
      list: [],
      form: {
        accountHolderName: this.userData.name,
        idNumber: this.userData.idNum ? this.userData.idNum : '暂无',
        account: "",
        fundPwd: "",
      },
      title: "添加支付宝账号",
      pageData: undefined,
    };
  },
  mounted() {
    this.accountList()
    this.getUserInfo()
  },
  methods: {

    // 0修改密码
    accountClick(vl) {
      console.log("----执行");
      
      this.$emit('accountClick', vl)
    },


    cancel() {
      this.dialogVisible = false;
    },
    // 新增账号
    addAccount() {
      // 立即添加操作
      if (this.form.alipayAccount == '' || this.form.fundPwd == '') {
        this.$message.error("请输入账号或者交易密码");
      }
      let params = {
        accType: 1,
        account: this.form.account,
        fundPwd: this.form.fundPwd,
      };

      http
        .post("/user/account/add", params)
        .then((response) => {
          if (response.code == 200) {
            this.$message("添加成功");
            this.accountList()
            this.cancel()
          } else {
            this.$message.error(response.msg);

          }
        })
    },

    //
    getUserInfo() {
      http
        .get("/user/base/info")
        .then((response) => {
          if (response.code === 200) {
            this.pageData = response.data;
            this.accountHolderName = this.pageData.name
            this.idNumber = this.pageData.idNum ? this.pageData.idNum : '暂无'
            
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },
    // 删除账号
    accountDel(vl) {
      this.$confirm('此操作将永久删除该账号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.del(vl)
      }).catch(() => {
      });

    },
    del(vl) {
      http
        .get("/user/account/del?accId=" + vl.accId)
        .then((response) => {
          if (response.code == 200) {
            this.accountList()
            this.$message.success("删除成功");
          } else {
            this.$message.error(response.msg);

          }
        })
    },
    //提现账户列表
    accountList() {
      http
        .get("/user/account/list?accType=1")
        .then((response) => {
          if (response.code == 200) {
            this.list = response.data;
          } else {
            this.$message.error(response.msg);

          }
        })
    },


    changePhomeClick(vl) { },
    tabAction(vl) {
      this.tab = vl;
    },
    // 添加账号
    addAcc() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.item-view {
  height: 80px;
  background-color: #eef5ff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 0px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  .item-left {
    display: flex;
    align-items: center;
    height: 100%;

    img {
      height: 50px;
      height: 50px;
    }
  }
}

.withdraw-account-form {
  max-width: 600px;
  margin: 0 auto;
}

.hint-view {
  margin: 0px 30px;
  height: 40px;
  margin-top: 50px;
  color: rgb(169, 83, 0);
  background: rgb(255, 244, 219);
  display: flex;
  align-items: center;
  font-size: 12px;
  color: rgb(169, 83, 0);
  padding: 0px 20px;
  border-radius: 10px;

  img {
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }
}

.tab-view {
  width: 100%;
  margin-top: 20px;
  padding: 0 20%;

  .tab-item {
    color: #000000a5;
    font-size: 16px;
    position: relative;
    padding-bottom: 15px;
  }

  .tab-line {
    position: absolute;
    bottom: 0;
    left: 8px;
    right: 8px;
    height: 5px;
    border-top-left-radius: 2.5px;
    border-top-right-radius: 2.5px;
    background-color: #488eff;
  }
}

.phone-container {
  background-color: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 30px;

  .no-data {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 400px;
      height: 250px;
    }

    .no-data-title {
      color: rgba(0, 0, 0, 0.647);
      font-family: "PingFang SC", sans-serif;
      font-size: 18px;
      font-weight: 400;
      margin: 0px;
    }
  }

  .no-autonym {
    padding-top: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 250px;
    color: #000000a5;
    font-family: PingFang SC, sans-serif;
    font-size: 18px;
    font-weight: 400;
    margin: 0;
    text-align: center;
    line-height: 40px;
  }
}
</style>